(function () {
  const currentUrl = window.location.href.toLowerCase();
  if (currentUrl.includes('synechron-email-signature')) {
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (isSafari && document.getElementById('safari-warning')) {
      document.getElementById('safari-warning').classList.remove('hidden');
      document.getElementById('safari-warning').classList.add('flex');
    }

    // countries array
    var countriesCode = [
      {
        code: '+1',
        name: 'Canada',
      },
      {
        code: '+1',
        name: 'USA',
      },
      {
        code: '+33',
        name: 'France',
      },
      {
        code: '+49',
        name: 'Germany',
      },
      {
        code: '+352',
        name: 'Luxembourg',
      },
      {
        code: '+31',
        name: 'Netherlands',
      },
      {
        code: '+381',
        name: 'Serbia',
      },
      {
        code: '+64',
        name: 'New Zealand',
      },
      {
        code: '+44',
        name: 'uk',
      },
      {
        code: '+971',
        name: 'uae',
      },
      {
        code: '+61',
        name: 'Australia',
      },
      {
        code: '+852',
        name: 'Hong Kong',
      },
      {
        code: '+91',
        name: 'India',
      },
      {
        code: '+81',
        name: 'Japan',
      },
      {
        code: '+65',
        name: 'Singapore',
      },
      {
        code: '+41',
        name: 'Switzerland',
      },
    ];
    var countries = [
      {
        text: 'Select country',
        value: 0,
      },
      {
        region: 'North America',
        childrens: [
          {
            text: 'Canada',
            value: 'canada',
          },
          {
            text: 'USA',
            value: 'usa',
          },
        ],
      },
      {
        region: 'EUROPE',
        childrens: [
          {
            text: 'France',
            value: 'france',
          },
          {
            text: 'Germany',
            value: 'germany',
          },
          {
            text: 'Luxembourg',
            value: 'luxembourg',
          },
          {
            text: 'Netherlands',
            value: 'netherlands',
          },
          {
            text: 'Serbia',
            value: 'serbia',
          },
          {
            text: 'Switzerland',
            value: 'switzerland',
          },
          {
            text: 'United Kingdom',
            value: 'uk',
          },
        ],
      },
      {
        region: 'MIDDLE EAST',
        childrens: [
          {
            text: 'United Arab Emirates',
            value: 'uae',
          },
        ],
      },
      {
        region: 'ASIA-PACIFIC',
        childrens: [
          {
            text: 'Australia',
            value: 'australia',
          },
          {
            text: 'Hong Kong',
            value: 'hong kong',
          },
          {
            text: 'India',
            value: 'india',
          },
          {
            text: 'Japan',
            value: 'japan',
          },
          {
            text: 'Singapore',
            value: 'singapore',
          },
          {
            text: 'New Zealand',
            value: 'new zealand',
          },
        ],
      },
    ];
    var countrySelect = document.getElementById('country');
    if (countrySelect) {
      countries.forEach((country) => {
        var option = document.createElement('option');
        if (country.value !== undefined) {
          option.value = country.value;
          option.text = country.text;
          countrySelect.add(option);
        }

        if (country.region) {
          var optgroup = document.createElement('optgroup');
          optgroup.label = country.region;
          countrySelect.add(optgroup);
          country.childrens.forEach((city) => {
            var nestedOption = document.createElement('option');
            nestedOption.value = city.value;
            nestedOption.text = city.text;
            optgroup.appendChild(nestedOption);
          });
        }
      });
    }

    var businessUnitsFD = [
      {
        department: 'Select your function',
        value: 0,
      },
      {
        department: 'Corporate',
        value: 'Corporate',
        childrens: [
          {
            text: 'Admin',
            value: 'Admin',
          },
          {
            text: 'EAG',
            value: 'EAG',
          },
          {
            text: 'Finance',
            value: 'Finance',
          },
          {
            text: 'HR',
            value: 'HR',
          },
          {
            text: 'InfoSec',
            value: 'InfoSec',
          },
          {
            text: 'L&D',
            value: 'L&D',
          },
          {
            text: 'Legal & Compliance',
            value: 'Legal & Compliance',
          },
          {
            text: 'Marketing & Communications',
            value: 'Marketing & Communications',
          },
          {
            text: 'Procurement',
            value: 'Procurement',
          },
          {
            text: 'Recruitment',
            value: 'Recruitment',
          },
          {
            text: 'Resourcing',
            value: 'Resourcing',
          },
          {
            text: 'Travel',
            value: 'Travel',
          },
          {
            text: 'Visa & Immigration',
            value: 'Visa & Immigration',
          },
        ],
      },
      {
        department: 'Technology',
        value: 'Technology',

        childrens: [
          {
            text: 'Artificial Intelligence',
            value: 'Artificial Intelligence',
          },{
            text: 'IT Operations',
            value: 'IT Operations',
          },
          {
            text: 'IT',
            value: 'IT',
          },
          {
            text: 'Payments',
            value: 'Payments',
          },
          {
            text: 'Quality Control',
            value: 'Quality Control',
          },
          {
            text: 'Systems',
            value: 'Systems',
          },
        ],
      },
      {
        department: 'Others',
        value: 'Others',
        childrens: [
          {
            text: 'BA',
            value: 'BA',
          },
          {
            text: 'Business Management',
            value: 'Business Management',
          },
          {
            text: 'Cloud & DevOps',
            value: 'Cloud & DevOps',
          },
          {
            text: 'Consulting',
            value: 'Consulting',
          },
          {
            text: 'Data',
            value: 'Data',
          },
          {
            text: 'Digital',
            value: 'Digital',
          },
          {
            text: 'Software Engineering',
            value: 'Software Engineering',
          },
          {
            text: 'FinLabs',
            value: 'FinLabs',
          },
          {
            text: 'PMO',
            value: 'PMO',
          },

          {
            text: 'Presales',
            value: 'Presales',
          },

          {
            text: 'SPEED',
            value: 'SPEED',
          },
          {
            text: 'Sales',
            value: 'Sales',
          },
        ],
      },
      {
        department: 'Not Listed',
        value: 'Not Listed',
        childrens: [
          {
            text: 'Type below',
            value: 'Type below',
          },
        ],
      },
    ];
    var businessUnitSelect = document.getElementById('unit');
    var businessUnitDeptFunctions = document.getElementById('deptAndFunctions');

    if (businessUnitSelect) {
      businessUnitsFD.forEach((bu) => {
        // var option = document.createElement('option');
        // if (bu.value !== undefined) {
        //   option.value = bu.value;
        //   option.text = bu.text;
        //   businessUnitSelect.add(option);
        // }

        if (bu.department) {
          var optgroup = document.createElement('option');
          optgroup.value = bu.value;
          optgroup.text = bu.department;

          businessUnitSelect.add(optgroup);
          // bu.childrens.forEach((buGroup) => {
          //   var nestedOption = document.createElement('option');
          //   nestedOption.value = buGroup.value;
          //   nestedOption.text = buGroup.text;
          //   optgroup.appendChild(nestedOption);
          // });
        }
      });
    }

    if (businessUnitDeptFunctions) {
      businessUnitsFD.forEach((bu) => {
        if (bu.department) {
          var ul = document.createElement('ul');
          let span = document.createElement('span');
          span.innerText = bu.department;
          span.className = 'font-medium border-b-2 mb-2';
          ul.className = 'flex flex-col grow px-2 md:w-1/2 lg:w-1/2 w-full ';
          ul.appendChild(span);
          if (bu.childrens) {
            bu.childrens.forEach((buGroup) => {
              var li = document.createElement('li');
              li.className = 'font-base ';
              li.innerText = buGroup.text;
              ul.appendChild(li);
            });
            businessUnitDeptFunctions.appendChild(ul);
          }
        }
      });
    }

    var co = document.getElementById('country'),
      cov = null,
      ci = document.getElementById('city'),
      civ = null,
      ci_txt = 'Select city',
      ci_val = '0',
      bu = document.getElementById('unit'),
      buv = null,
      buvf = '';
    var cities = {},
      file = '',
      iframe = document.getElementById('signature'),
      i = 0,
      next = document.getElementById('next'),
      signaturefooter = document.getElementById('signaturefooter'),
      signatureInnerContent = document.getElementById('signatureInnerContent');

    var citiesCustomArr = [];
    var countryPrefix;
    var originalData = [];
    if (next) {
      next.style.display = 'none';
    }

    let fetchRes = fetch(location.origin + '/json-office-city-counry');
    // fetchRes is the promise to resolve
    // it by using.then() method
    fetchRes
      .then((res) => res.json())
      .then((data) => {
        data.forEach(function (element, index) {
          // console.log('element', element);
          originalData.push(element);
          if (
            element.field_city == 'Bengaluru' ||
            element.field_city == 'Pune' ||
            element.field_city == 'Hyderabad' ||
            element.field_city == 'Auckland' ||
            element.field_city == 'Dubai'
          ) {
            citiesCustomArr.push([
              element.sub_city,
              element.field_country.toLowerCase(),
              element.sub_city.toLowerCase(),
              element.field_address,
              element.field_city,
              element.sub_city,
            ]);
            originalData[index].field_city = element.sub_city;
          } else {
            citiesCustomArr.push([
              element.field_city,
              element.field_country.toLowerCase(),
              element.field_city.toLowerCase(),
              element.field_address,
              element.field_city,
              element.sub_city,
            ]);
          }

          countryPrefix = element.field_country.toLowerCase();
          cities[countryPrefix] = new Array();
        });
        citiesCustomArr.forEach(function (cityArr) {
          originalData.forEach(function (originalArr) {
            if (
              cityArr[0] == originalArr.field_city &&
              cityArr[3] == originalArr.field_address
            ) {
              cities[cityArr[1]].push(cityArr);
            }
          });
        });
      });

    const country = document.querySelector('#country');
    const city = document.querySelector('#city');
    const unit = document.querySelector('#unit');
    var departmentUnitSelect = document.getElementById('departmentSelect');

    // start of first name, last name and contact number
    const signatureName = document.querySelector('#signatureName');
    const signContact = document.querySelector('#signContact');
    const signPhone = document.querySelector('#signPhone');
    const signPronounce = document.querySelector('#signPronounce');
    const signJobTitle = document.querySelector('#signJobTitle');

    const fnlnWrapperHtml = document.getElementById('fnlnWrapper');
    const signatureContactHtml = document.getElementById('signatureContact');
    const signaturePhoneHtml = document.getElementById('signaturePhone');
    const signaturePronounceHtml =
      document.getElementById('signaturePronounce');
    const signaturePhSymbolHtml = document.getElementById('signaturePhSymbol');
    const jobDescriptionHtml = document.getElementById('jobDescription');
    const countryCodeMobileHtml = document.getElementById('countryCodeMobile');
    const countryCodePhoneHtml = document.getElementById('countryCodePhone');
    const signatureContactPhHtml =
      document.getElementById('signatureContactPh');
    const signaturePhonePhHtml = document.getElementById('signaturePhonePh');
    const neImageBannerHtml = document.getElementById('neImageBanner');
    const departmentDataHtml = document.getElementById('departmentData');

    // const copySignBtn = document.getElementById("copySignBtn");

    if (fnlnWrapperHtml) {
      fnlnWrapperHtml.innerHTML = 'First name Last name';
    }
    // if (signaturePronounceHtml) {
    //   signaturePronounceHtml.innerHTML = "Pronouns";
    // }
    if (jobDescriptionHtml) {
      // jobDescriptionHtml.innerHTML = 'Job Title -' + '&nbsp;';
      jobDescriptionHtml.innerHTML = 'Job Title';
    }

    if (signatureContactPhHtml) {
      signatureContactPhHtml.innerHTML = 'Mobile';
    }
    // if (signaturePhonePhHtml) {
    //   signaturePhonePhHtml.innerHTML = "Phone";
    // }
    const fullNameHanlder = function (e) {
      fnlnWrapperHtml.innerHTML = e.target.value;
      if (!e.target.value) {
        fnlnWrapperHtml.innerHTML = 'First name Last name';
      }
    };
    const signPhoneHandler = function (e) {
      signatureContactHtml.innerHTML = e.target.value;

      if (!e.target.value) {
        signatureContactPhHtml.innerHTML = 'Mobile';
      }
    };
    const signContactPhoneHandler = function (e) {
      signaturePhoneHtml.innerHTML = e.target.value;
      if (!e.target.value) {
        signaturePhonePhHtml.innerHTML = 'Phone';
      }
    };

    const signJobTitleHandler = function (e) {
      jobDescriptionHtml.innerHTML = e.target.value + ' ';
      // if (e.target.value && signatureJobSymbol) {
      //   signatureJobSymbol.style.display = 'inline-block';
      // } else {
      //   signatureJobSymbol.style.display = 'none';
      // }
      let selectedFunction = document.getElementById('unit').value;
      if (!e.target.value) {
        if (selectedFunction !== 'Not Listed') {
          jobDescriptionHtml.innerHTML = 'Job Title ';
        } else {
          jobDescriptionHtml.innerHTML = 'Job Title - Department';
        }
      }
    };

    if (signatureName) {
      signatureName.addEventListener('input', fullNameHanlder);
    }

    if (signPhone) {
      signPhone.addEventListener('input', signPhoneHandler);
    }
    if (signContact) {
      signContact.addEventListener('input', signContactPhoneHandler);
    }

    if (signJobTitle) {
      signJobTitle.addEventListener('input', signJobTitleHandler);
    }
    // if (copySignBtn) {
    //   copySignBtn.addEventListener("click", copyToClipboard);
    // }

    // function copyToClipboard() {
    //   if (document.selection) {
    //     var range = document.body.createTextRange();
    //     range.moveToElementText(document.getElementById("signature"));
    //     range.select().createTextRange();
    //     document.execCommand("copy");
    //   } else if (window.getSelection) {
    //     var range = document.createRange();
    //     range.selectNode(document.getElementById("signature"));
    //     window.getSelection().addRange(range);
    //     document.execCommand("copy");
    //   }
    // }

    if (departmentUnitSelect) {
      departmentUnitSelect.onchange = function (e) {
        if (e.target.value !== '0') {
          departmentDataHtml.innerHTML = '-' + '&nbsp;' + e.target.value;
          if (next) {
            next.style.display = 'block';
          }
        } else {
          if (next) {
            next.style.display = 'none';
          }
          departmentDataHtml.innerHTML = '';
        }
      };
    }
    if (signPronounce) {
      signPronounce.onchange = function (e) {
        selectPronounce(e);
      };
    }

    function selectPronounce(event) {
      if (event) {
        signaturePronounceHtml.innerHTML = event.target.value;
      }
    }
    // end of first name, last namr and contact number

    if (country) {
      country.onchange = function (e) {
        selectSignature(e);

        countriesCode.forEach((country) => {
          if (country.name.toLowerCase() == e.target.value) {
            countryCodeMobileHtml.innerHTML = country.code + ' ';
            // countryCodePhoneHtml.innerHTML = country.code + " ";
          }
        });
      };
    }

    if (city) {
      city.onchange = function (e) {
        selectSignature(e);
      };
    }
    if (unit) {
      unit.onchange = function (e) {
        selectSignature(e);
      };
    }
    function selectSignature(o) {
      if (departmentDataHtml) {
        departmentDataHtml.innerHTML = '';
      }
      if (co) {
        cov = co.options[co.selectedIndex].value;
      }
      if (ci) {
        civ = ci.options[ci.selectedIndex].value;
      }
      if (bu) {
        buv = bu.options[bu.selectedIndex].value;
      }

      while (departmentUnitSelect && departmentUnitSelect.options.length > 0) {
        departmentUnitSelect.remove(0);
      }
      if (departmentUnitSelect && buv != 'Not Listed') {
        let defaultOptGroup = document.createElement('option');
        defaultOptGroup.value = 'Select your department';
        defaultOptGroup.text = 'Select your department';
        departmentUnitSelect.add(defaultOptGroup);
      }
      if (signJobTitle) {
        signJobTitle.value = '';
        if (buv == 'Not Listed') {
          signJobTitle.placeholder = 'Job Title - Department';
          jobDescriptionHtml.innerHTML = 'Job Title - Department';
        } else {
          signJobTitle.placeholder = 'Job Title';
          jobDescriptionHtml.innerHTML = 'Job Title ';
        }
      }

      if (departmentUnitSelect) {
        buv == 0 || buv == 'Not Listed'
          ? (departmentUnitSelect.disabled = true)
          : (departmentUnitSelect.disabled = false);
      }
      businessUnitsFD.forEach((bu) => {
        if (bu.department == buv) {
          bu.childrens.forEach((su) => {
            var optgroup = document.createElement('option');
            optgroup.value = su.value;
            optgroup.text = su.text;
            departmentUnitSelect.add(optgroup);
          });
        }
      });
      if (o && o.target != ci && o.target != bu) {
        if (cov == '0') {
          removeOptions();
          ci.options.length = 1;
          ci.options[0].text = ci_txt;
          ci.options[0].value = ci_val;
          CL_jsCss('add', ci, 'placeholder');
          ci.disabled = true;
          CL_jsCss('add', ci.parentNode, 'disabled');
        } else {
          removeOptions();
          items = cities[cov];
          // console.log('items', items);
          if (items) {
            ci.disabled = false;
            CL_jsCss('remove', ci.parentNode, 'disabled');
            ci.options.length = 1;
            if (items.length == 1) {
              removeOptions();
              fetchCities(items, ci);
            } else {
              removeOptions();
              fetchCities(items, ci);
            }
          }
        }
      }

      if (cov == '0') {
        CL_jsCss('add', co, 'placeholder');
      } else {
        CL_jsCss('remove', co, 'placeholder');
      }
      if (civ == '0') {
        CL_jsCss('add', ci, 'placeholder');
      } else {
        CL_jsCss('remove', ci, 'placeholder');
      }
      if (buv == '0') {
        CL_jsCss('add', bu, 'placeholder');
      } else {
        CL_jsCss('remove', bu, 'placeholder');
      }

      if (co) {
        cov = co.options[co.selectedIndex].value;
      }
      if (ci) {
        civ = ci.options[ci.selectedIndex].value;
      }
      if (bu) {
        buv = bu.options[bu.selectedIndex].value;
      }
      if (
        buv == '0' ||
        civ == '0' ||
        (departmentUnitSelect && departmentUnitSelect.value == '0')
      ) {
        if (next) {
          next.style.display = 'none';
        }
      } else {
        if (next) {
          next.style.display = 'block';
        }
      }
      if (cov != '0' && civ != '0' && buv != '0') {
        // jQuery("#signaturefooter").hide();
        if (signaturefooter) {
          signaturefooter.style.display = 'none';
        }
        //jQuery("#next").removeClass("show");
        if (next) {
          next.classList.remove('show');
        }
        // jQuery("#signatureInnerContent").html("");
        if (signatureInnerContent) {
          signatureInnerContent.innerHTML = '';
        }

        if (buv == '') {
          buvf = '';
        } else {
          buvf = buv;
        }
        var divsignature = '#synechron_' + cov + '_' + civ + buvf;
        var jobTitleHtml = document.getElementById('jobTitle');
        // var departmentTitleHtml = document.getElementById('departmentTitle');

        var extnHtml = document.getElementById('extn');
        var selectedDepartment;
        businessUnitsFD.forEach((data) => {
          // if (data.childrens) {
          //   data.childrens.forEach((dept) => {
          //     if (dept.value == buvf) {
          //       selectedDepartment = data.department;
          //     }
          //   });
          // }
          if (data && data.value !== 0) {
            if (data.value == buvf) {
              selectedDepartment = data.value;
            }
          }
        });
        if (typeof divsignature !== 'undefined' && divsignature !== null) {
          // var userInput = jQuery(divsignature).html();
          // var jobTitle =
          //   "<span class='grey' style='border:0'> " + buvf + '</span>';

          // jQuery("#jobTitle").html(jobTitle);
          if (jobTitleHtml) {
            jobTitleHtml.innerHTML = jobTitle;
          }
          // if (departmentTitleHtml) {
          //   var deptTitle =
          //     "<span class='grey' style='border:0'> - " +
          //     selectedDepartment +
          //     '</span>';

          //   if (selectedDepartment == 'Not Listed') {
          //     departmentTitleHtml.innerHTML = '';
          //   } else {
          //     departmentTitleHtml.innerHTML = deptTitle;
          //   }
          // }

          originalData.forEach((data) => {
            if (
              data.field_country.toLowerCase() == cov &&
              data.sub_city.toLowerCase() == civ
            ) {
              userInput = data.field_address.replace(
                /(<|&lt;)br\s*\/*(>|&gt;)/g,
                ' '
              );
              userInput = userInput.replace(
                'Reg. No. CIN U72200PN2001PTC016029',
                ''
              );
            }
          });
          // console.log("userInput", userInput);
          // jQuery("#signatureInnerContent").html(userInput);

          // if (extnHtml) {
          //   extnHtml.innerHTML = "Extn: XXXX";
          // }
          if (signatureInnerContent) {
            signatureInnerContent.innerHTML = userInput;
          }
          if (typeof userInput !== 'undefined' && userInput !== null) {
            if (divsignature.toLowerCase().indexOf('_nl_') >= 0) {
              // jQuery("#signaturefooter").show();
              if (signaturefooter) {
                signaturefooter.style.display = 'block';
              }
            }
            CL_jsCss('add', next, 'show');
            CL_smoothScroll('step_1');
          }
        }
      } else {
        CL_jsCss('remove', next, 'show');
      }
    }

    function CL_jsCss(a, o, c1, c2) {
      if (o) {
        switch (a) {
          case 'swap':
            o.className = !CL_jsCss('check', o, c1)
              ? o.className.replace(c2, c1)
              : o.className.replace(c1, c2);
            break;
          case 'add':
            if (!CL_jsCss('check', o, c1)) {
              o.className += o.className ? ' ' + c1 : c1;
            }
            break;
          case 'remove':
            var rep = o.className.match(' ' + c1) ? ' ' + c1 : c1;
            o.className = o.className.replace(rep, '');
            break;
          case 'check':
            return new RegExp('\\b' + c1 + '\\b').test(o.className);
            break;
        }
      }
    }

    function CL_curPosY() {
      if (self.pageYOffset) {
        return self.pageYOffset;
      }
      if (document.documentElement && document.documentElement.scrollTop) {
        return document.documentElement.scrollTop;
      }
      if (document.body.scrollTop) {
        return document.body.scrollTop;
      }
      return 0;
    }

    function CL_elPosY(id) {
      var e = document.getElementById(id),
        y = e.offsetTop,
        n = e;
      while (n.offsetParent && n.offsetParent != document.body) {
        n = n.offsetParent;
        y += n.offsetTop;
      }
      return y;
    }

    function CL_smoothScroll(id) {
      var startY = CL_curPosY(),
        stopY = CL_elPosY(id);
      var d = stopY > startY ? stopY - startY : startY - stopY;
      if (d < 100) {
        scrollTo(0, stopY);
        return;
      }
      var speed = Math.round(d / 100);
      if (speed >= 20) {
        speed = 20;
      }
      var step = Math.round(d / 25);
      var leapY = stopY > startY ? startY + step : startY - step;
      var timer = 0;
      if (stopY > startY) {
        for (var i = startY; i < stopY; i += step) {
          setTimeout('window.scrollTo(0, ' + leapY + ')', timer * speed * 10);
          leapY += step;
          if (leapY > stopY) {
            leapY = stopY;
          }
          timer++;
        }
        return;
      }
      for (var i = startY; i > stopY; i -= step) {
        setTimeout('window.scrollTo(0, ' + leapY + ')', timer * speed * 10);
        leapY -= step;
        if (leapY < stopY) {
          leapY = stopY;
        }
        timer++;
      }
    }

    // functionality to remove options and optgroup on selection of country
    function removeOptions() {
      while (ci.options.length > 0) {
        document
          .querySelectorAll('#city option')
          .forEach((option) => option.remove());
        document
          .querySelectorAll('#city optgroup')
          .forEach((optgroup) => optgroup.remove());
      }
    }

    // function to group city and their locations together
    function fetchCities(items, ci) {
      ci.options.length = 1;
      // to group data based on city and their location
      result = items.reduce(function (r, a) {
        r[a[4]] = r[a[4]] || [];
        r[a[4]].push(a);
        return r;
      }, Object.create(null));

      ci.options[0].text = ci_txt;
      ci.options[0].value = ci_val;
      const entries = Object.entries(result);
      // create cities based on new data
      for (i = 0; i < entries.length; i++) {
        for (j = 1; j < entries[i].length; j++) {
          var gr = document.createElement('OPTGROUP');
          gr.label = entries[i][0];
          for (k = 0; k < entries[i][j].length; k++) {
            if (entries[i][j][k][0]) {
              opt = document.createElement('OPTION');
              opt.textContent = entries[i][j][k][5];
              opt.value = entries[i][j][k][5].toLowerCase();
              gr.appendChild(opt);
            }
            ci.appendChild(gr);
          }
        }
      }
    }
    selectSignature();
    selectPronounce();
    // copyToClipboard();
    var urls;
    let fetchImages = fetch(
      location.origin + '/email-signature-event-pages-list'
    );
    // fetchRes is the promise to resolve
    // it by using.then() method
    fetchImages
      .then((res) => res.json())
      .then((data) => {
        urls = data;
        const radioButtonsWrapElem = document.getElementById(
          'radioButtonsWrapElem'
        );

        if (radioButtonsWrapElem) {
          data.forEach((data) => {
            let radioButtonWrapper = document.createElement('div');
            radioButtonWrapper.className =
              'flex my-2 md:w-w-3/12 lg:w-3/12 w-full p-4 items-center ';
            let radioInput = document.createElement('input');
            radioInput.type = 'radio';
            radioInput.id = data.id;
            radioInput.name = 'banner-radio';
            radioInput.value = data.id;
            let radioImage = document.createElement('img');
            radioImage.src = location.origin + data.Image;
            radioInput.className = 'radio-input';
            radioImage.className = 'ml-2 inline h-full w-full';
            radioButtonWrapper.appendChild(radioInput);
            radioButtonWrapper.appendChild(radioImage);
            radioButtonsWrapElem.appendChild(radioButtonWrapper);
          });

          let radioInputs = document.querySelectorAll('.radio-input');
          radioInputs.forEach(function (input, index) {
            input.addEventListener('click', handleChange);
          });
          function handleChange(e) {
            let inputValue = e.target.value;

            radioInputs.forEach(function (input, index) {
              let imageBannerWrapper =
                document.getElementById('imageSignBanner');
              if (input.value === inputValue) {
                if (inputValue == 'default-radio') {
                  imageBannerWrapper.innerHTML = '';
                  return false;
                }
                imageBannerWrapper.innerHTML = '';

                let imageWrapper = document.createElement('img');
                imageWrapper.setAttribute('width', 250);
                imageWrapper.src = location.origin + urls[index - 1].Image;
                if (urls[index - 1].ImgClickLink != '') {
                  let imageLink = document.createElement('a');
                  imageLink.setAttribute('target', '_blank');
                  imageLink.href = urls[index - 1].ImgClickLink;
                  imageLink.appendChild(imageWrapper);
                  imageBannerWrapper.appendChild(imageLink);
                } else {
                  imageBannerWrapper.appendChild(imageWrapper);
                }
              }
            });
          }
        }
      });
  }
})();
